import {CombinedOrderElementDto} from "../models/core/combined-order-element-dto";
import {RevenueCalculationStrategy} from "../../common/enums/strategies/revenue-calculation-strategy";

/**
 * Maps every {@link RevenueCalculationStrategy} to its value on a combined order element (#142 — all
 * four strategies are wired; previously only the first two existed and selecting a source-details
 * strategy resolved to `undefined`). `sourceDetailsCost` defaults to 0 until a data source populates it,
 * so the source-details strategies gracefully equal their gross counterparts in views without cost data.
 */
export class RevenueCalculationMethod {
  static fnMapping: { [key in RevenueCalculationStrategy]: (combinedOrderElementDto: CombinedOrderElementDto) => number } = {
    [RevenueCalculationStrategy.revenue]:
      (combinedOrderElementDto: CombinedOrderElementDto) => combinedOrderElementDto.revenue,
    [RevenueCalculationStrategy.revenueExcludingTaxes]:
      (combinedOrderElementDto: CombinedOrderElementDto) => combinedOrderElementDto.revenueAfterTax,
    [RevenueCalculationStrategy.revenueExcludingSourceDetails]:
      (combinedOrderElementDto: CombinedOrderElementDto) => combinedOrderElementDto.revenue - combinedOrderElementDto.sourceDetailsCost,
    [RevenueCalculationStrategy.revenueExcludingTaxesAndSourceDetails]:
      (combinedOrderElementDto: CombinedOrderElementDto) => combinedOrderElementDto.revenueAfterTax - combinedOrderElementDto.sourceDetailsCost,
  }
}
